import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('generativelanguage.googleapis.com')) {
      return next.handle(request);
    }

    const token = localStorage.getItem('token');
    let httpHeaders = request.headers;

    if (token) {
      httpHeaders = httpHeaders.set('Authorization', 'Bearer ' + token);
    }

    if (!request.url.includes('upload')) {
      httpHeaders = httpHeaders
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');
    }

    return next.handle(request.clone({ headers: httpHeaders }));
  }
}


